import api from '@/api'
import _ from 'lodash'

export default {
  state: {
  },

  getters: {
  },

  mutations: {
  },

  actions: {
    async fetchReport({}, filters) {
      let error;

      try {
        let resource = filters.reportType.valueOf();

        const response = await api.get(`/reports/${resource}/false`, {
          params: {
            categories: filters.categories ? filters.categories.map(e => e.id).join(',') : undefined,
            organizers: filters.organizer.persons ? filters.organizer.persons.map(e => e.id).join(',') : undefined,
            initialDepartments: filters.initiator.departments ? filters.initiator.departments.map(e => e.id).join(',') : undefined,
            organizerDepartments: filters.organizer.departments ? filters.organizer.departments.map(e => e.id).join(',') : undefined,
            method: filters.tender.method ? filters.tender.method.valueOf() : undefined,
            open: filters.tender.participationMode ? filters.tender.participationMode === api.TenderParticipationMode.OPEN : undefined,
            lotId: _.get(filters, 'lotNumber.id'),
            tenderNum: filters.tenderNumber || undefined,
            dtCreateFrom: +filters.creationDate.from || filters.creationDate.from ,
            dtCreateTo: +filters.creationDate.to || filters.creationDate.to,
            dtPublicationFrom: +filters.publicationDate.from || filters.publicationDate.from,
            dtPublicationTo: +filters.publicationDate.to || filters.publicationDate.to,
            currency: filters.price.currency,
            summFrom: filters.price.from,
            summTo: filters.price.to,
            countLot: filters.countLot
          }
        });
        const { status, result, errorCode } = response.data;
        
        if (status === 200) {
          return result.items || [];
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async exportReport({}, filters) {
      let error;

      try {
        let resource = filters.reportType.valueOf();

        await api.download(`/reports/${resource}/true`, {
          params: {
            categories: filters.categories ? filters.categories.map(e => e.id).join(',') : undefined,
            organizers: filters.organizer.persons ? filters.organizer.persons.map(e => e.id).join(',') : undefined,
            initialDepartments: filters.initiator.departments ? filters.initiator.departments.map(e => e.id).join(',') : undefined,
            organizerDepartments: filters.organizer.departments ? filters.organizer.departments.map(e => e.id).join(',') : undefined,
            method: filters.tender.method ? filters.tender.method.valueOf() : undefined,
            open: filters.tender.participationMode ? filters.tender.participationMode === api.TenderParticipationMode.OPEN : undefined,
            lotId: _.get(filters, 'lotNumber.id'),
            tenderNum: filters.tenderNumber || undefined,
            dtCreateFrom: +filters.creationDate.from || filters.creationDate.from ,
            dtCreateTo: +filters.creationDate.to || filters.creationDate.to,
            dtPublicationFrom: +filters.publicationDate.from || filters.publicationDate.from,
            dtPublicationTo: +filters.publicationDate.to || filters.publicationDate.to,
            currency: filters.price.currency,
            summFrom: filters.price.from,
            summTo: filters.price.to,
            countLot: filters.countLot
          }
        }, {
          filename: 'report.xlsx'
        });
      }
      catch(e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    }
  }
}
